import { connect } from 'react-redux';
import CambioContrasena from "./CambioContrasena";
import {
    getConfiguracionContrasena,
    actualizarContrasena,
    reiniciarStateCambioContrasena
} from '../actions/ChangePasswordActions';

import { setFlagAccesoDirecto } from '../../TopMenu/Actions.jsx'

const mapStateToProps = (state) => {
    return {
        executionContext: state.sesion.executionContext,
        configuracionContrasena: state.cambioContrasena.configuracionContrasena,
        routeToLogin: state.cambioContrasena.routeToLogin,
        mensaje: state.cambioContrasena.mensaje,
        exitoCambioPass: state.cambioContrasena.exitoCambioPass,
        loggedIn: state.sesion.loggedIn
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getConfiguracionContrasena: () => {
            dispatch(getConfiguracionContrasena());
        },
        actualizarContrasena: (data) => {
            dispatch(actualizarContrasena(data));
        },
        reiniciarStateCambioContrasena: () => {
            dispatch(reiniciarStateCambioContrasena());
        },
        setFlagAccesoDirecto: () => {
            dispatch(setFlagAccesoDirecto());
        }
    }
}

const ConnectedCambioContrasena = connect(mapStateToProps, mapDispatchToProps)(CambioContrasena)

export default ConnectedCambioContrasena;



// WEBPACK FOOTER //
// ./Portico/App/Screens/CambioContrasena/components/CambioContrasenaContainer.js